import React, { useState, useEffect } from 'react';
import TimetableManager from './TimetableManager';
import { api } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

const TimetablePage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeYear, setActiveYear] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // `getActive()` rend un objet sans dates des qu'un identifiant est en
        // localStorage. La generation annuelle a besoin des bornes : on passe
        // donc par la porte qui va les chercher en base.
        const activeYearResponse = await api.anneesScolaires.getActiveAvecDates();

        if (activeYearResponse.success && activeYearResponse.data) {
          setActiveYear(activeYearResponse.data);
        } else {
          setError("Aucune année scolaire active n'est définie");
        }
      } catch (error) {
        setError("Erreur lors du chargement des données");
      } finally {
        setLoading(false);
      }
    };
    
    loadData();
  }, []);

  // 🔹 Si ça charge → afficher uniquement ton spinner global
  if (loading) {
    return <LoadingSpinner />;
  }

  // 🔹 Si erreur → affichage du message
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-[#246990] text-white rounded hover:bg-[#1e5576]"
          >
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  // 🔹 Si tout est chargé correctement
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-6">
        {/* La ligne « Année scolaire : … » vivait ici. L'année est déjà portée
            par le sélecteur global, et cette redite creusait un vide entre le
            titre et la grille — d'autant que `mb-8` s'ajoutait au `p-6` de la
            carte en dessous. */}
        <h1 className="mb-4 text-3xl font-bold text-[#246990]">Emploi du Temps</h1>

        <div className="bg-white rounded-xl shadow-sm p-6">
          <TimetableManager activeYear={activeYear} />
        </div>
      </div>
    </div>
  );
};

export default TimetablePage;
